/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useContext, useEffect } from 'react';
import {
    object, string, shape, arrayOf, number, func, array, bool,

} from 'prop-types';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { UIDReset, UIDConsumer } from 'react-uid';
import { useMediaQuery } from '@material-ui/core';
import { decode as htmlDecode } from '../../../../../pages/Account/utils/htmlEntity';
import RedirectToSku from '../common/RedirectToSku';
import { selectedSkuType } from '../common/types';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import Upsells from './Upsells';
import { brandByCode } from '../../../../Checkout/containers/CheckoutFood/components/Partials/Helper/Helper';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    goDeluxeContainer: {
        // Mobile
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },

    heading: {
        textTransform: 'uppercase',
        margin: '10px 4px 10px',
        fontSize: '0.9em',
        fontWeight: 'bold',
    },
    skusCard: {
        width: '50%',
        margin: '0 0 20px 0',
        cursor: 'pointer',
        '& img': {
            width: '100%',
        },
        background: theme.palette.white,
        border: 'none',
    },
    skusContent: {
        textAlign: 'center',
    },
    skusTitle: {
        color: theme.palette.black,
        minHeight: '25px',
        margin: '6px 12px 4px',
        overflow: 'hidden',
        fontSize: '1.2em',
        maxHeight: '40px',
        lineHeight: '1',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '2',
    },
    skuLabelAmount: {
        color: theme.palette.cms?.skuLabelAmountColor,
        fontSize: '1.2em',
        textAlign: 'center',
        fontWeight: '700',
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        fontWeight: '400',
    },
    salePrice: {
        color: theme.palette.pdp.salePrice || '#a1001a',
        margin: '0 0 0 10px',
    },
    selectedSalePrice: {
        fontWeight: 'bold',
    },
    discountAmount: {
        color: theme.palette.cms?.skuPriceDiscountColor,
        fontWeight: 'normal',
        marginLeft: '10px',
        fontSize: '0.8em',
    },
    selectedRetailPrice: {
        fontWeight: 'bold',
        color: theme.palette.common?.black,
        fontSize: '0.9em',
    },
    retailPrice: {
        fontSize: '0.9em',
        color: theme.palette.common?.black,
    },
});
const renderSkuPrice = (sku, classes, clubPrice = false) => {
    const round = (value) => Number(`${Math.round(value * 10) / 10}`).toFixed(2);
    const priceNonSelected = clubPrice ? classes.clubPrice : classes.retailPrice;
    if (sku?.prices?.[0] && sku?.prices?.[1]) {
        return sku.prices[0].value > sku.prices[1].value
            ? (
                <>
                    <s>
                        ${sku.prices[0].value}
                    </s>
                    <span className={`${classes.salePrice} ${classes.selectedSalePrice}`}>
                        ${sku.prices[1].value}
                    </span>
                    <span className={classes.discountAmount}>
                        ${round(sku.prices[0].value - sku.prices[1].value)} Off
                    </span>
                </>
            )
            : (
                <span className={priceNonSelected}>
                    ${sku.prices[0].value}
                </span>
            );
    }
    return null;
};
const GoDeluxe = ({
    classes,
    handleSkuChange,
    goDeluxeUpsells,
    selectedSku,
    sortedData,
    clubProduct,
    upsellNewDesign,
    skuConfig,
    isPdpRedesignEnabled,
}) => {
    const { presentation_family: presentationFamily  = '' } = useContext(CrossMerch);
    const dispatch = useDispatch();

    const isSmallerDevice = useMediaQuery('(max-width: 767px)');
    // Removing this design from any feature and abtest
    const upsellRedesign = presentationFamily === 'food';

    useEffect(() => {
        if (!upsellNewDesign && !upsellRedesign) {
            const upsellList = (goDeluxeUpsells || []).map((item) => item.id);
            const eventParam = {
                eventCategory: 'PDP Upsell',
                eventAction: `Default Upsell | ${selectedSku?.id} | Demand Type UP`,
                eventLabel: `Upsells ${upsellList?.join?.(',')}`,
            };
            dispatch(trackEvent(eventParam));
        }
    }, []);
    if (presentationFamily !== 'food'
    || sortedData?.length <= 1
    || clubProduct
    || goDeluxeUpsells?.length <= 0) {
        return null;
    }

    const isSkuShownOnMobile = skuConfig?.show_sku_on_mobile;

    if (upsellNewDesign && upsellRedesign && !isPdpRedesignEnabled && isSmallerDevice && !isSkuShownOnMobile) {
        return (
            <Upsells
                upsells={goDeluxeUpsells}
                brandName={brandByCode[selectedSku.brandId]}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        );
    }

    // TODO:: Below code seems dead code. As it's required "upsellRedesign" to false and it's "presentation family === food", if we pass any other presentation, code exit at line 156,
    return !upsellNewDesign && !upsellRedesign ? (
        <div className={classes.goDeluxeContainer}>
            <RedirectToSku
                selectedSkuId={selectedSku?.id}
                onChange={handleSkuChange}
            >
                {({ redirectToSku }) => (
                    <>
                        <div className={classes.heading}>Go Deluxe</div>
                        <UIDReset>
                            <UIDConsumer>
                                {(id, uid) => goDeluxeUpsells.map((sku) => (
                                    <button type="button" className={classes.skusCard} key={`skus${uid(sku.name)}`} onClick={(e) => redirectToSku(e, sku)}>
                                        <img src={`${sku.image?.path}${sku.image?.name}x.jpg`} alt={sku.name} />
                                        <div className={classes.skusContent}>
                                            <p className={classes.skusTitle}>{htmlDecode(sku.name)}</p>
                                            <div className={classes.skuLabelAmount}>{renderSkuPrice(sku, classes)}</div>
                                        </div>
                                    </button>
                                ))}
                            </UIDConsumer>
                        </UIDReset>
                    </>
                )}
            </RedirectToSku>
        </div>

    ) : <></>;
};

GoDeluxe.propTypes = {
    sortedData: array.isRequired,
    clubProduct: bool.isRequired,
    classes: object.isRequired,
    goDeluxeUpsells: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ).isRequired,
    handleSkuChange: func.isRequired,
    selectedSku: selectedSkuType,
    upsellNewDesign: bool,
    skuConfig: shape({
        show_sku_on_mobile: bool,
    }),
    isPdpRedesignEnabled: bool,
};

GoDeluxe.defaultProps = {
    selectedSku: {},
    skuConfig: {},
    upsellNewDesign: false,
    isPdpRedesignEnabled: false,

};

const enhance = compose(
    withStyles(styles),
    withRouter,
);

export default enhance(GoDeluxe);
